import * as React from 'react';
import { styled } from './druid/./druid/Utilities';
import { MessageBarBase } from '/druid/MessageBar.base';
import { getStyles } from '/druid/MessageBar.styles';
import { IMessageBarProps, IMessageBarStyleProps, IMessageBarStyles } from '/druid/MessageBar.types';

export const MessageBar: React.FunctionComponent<IMessageBarProps> = styled<
  IMessageBarProps,
  IMessageBarStyleProps,
  IMessageBarStyles
>(MessageBarBase, getStyles, undefined, {
  scope: 'MessageBar',
});
